import { infiniteQueryOptions, keepPreviousData, queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";
import type { ApiQueryParams } from "@/types/api-types";

export const useCompanyQueries = () => {
  const projectId = useProjectId();
  const api = useApi();

  const COMPANY_AMOUNT = 40;

  return {
    list: () =>
      queryOptions({
        queryKey: QUERY_KEYS.COMPANIES(projectId),
        queryFn: () => api.getCompaniesV1({ Limit: 10000, Offset: 0 }),
        select: commonAPIDataSelector,
      }),
    listInfinite: (searchQuery: string, sortBy: ApiQueryParams<"getCompaniesV1">["SortBy"], sortDescending: boolean) =>
      infiniteQueryOptions({
        queryKey: QUERY_KEYS.COMPANY_LIST_INFINITE(projectId, { searchQuery, sortBy, sortDescending }),
        queryFn: ({ pageParam = 0 }) =>
          api
            .getCompaniesV1({
              Limit: COMPANY_AMOUNT,
              Offset: pageParam * COMPANY_AMOUNT,
              search: searchQuery,
              SortBy: sortBy,
              SortDescending: sortDescending,
            })
            .then((x) => x.data),
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => (lastPage?.hasMore ? pages?.length : undefined),
        placeholderData: keepPreviousData,
      }),
    details: (companyId: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.COMPANY_DETAILS(projectId, companyId),
        queryFn: () => api.getCompaniesDetailsV1(companyId),
        select: commonAPIDataSelector,
      }),
  };
};
